import { Box, Item } from 'devextreme-react/box';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import {
	ActionHistoryButton,
	CloseLeadButton,
	CreateRevisionButton,
	CustomerInformationPanel,
	EstimateDatesPanel,
	EstimateFilesButton,
	EstimateInformationPanel,
	EstimateItemsGrid,
	EstimateNotesGrid,
	EstimatePage,
	EstimateProgress,
	EstimateProgressStep,
	ExitButton,
	SaveButton,
	StoreInformationPanel
} from '../../../features/cfi/estimate';
import '../../../css/order.scss';

export default function EstimateInfoPage() {

	return (

		<EstimatePage>

			<EstimateProgress />

			<Toolbar className='button-toolbar'>
				<ToolbarItem location={'before'}>
					<SaveButton step={EstimateProgressStep.Info} />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<CreateRevisionButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<ActionHistoryButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<EstimateFilesButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<CloseLeadButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<ExitButton />
				</ToolbarItem>
			</Toolbar>
			<Box>
				<Item ratio={1}>
					<EstimateInformationPanel />
				</Item>
				<Item ratio={1}>
					<EstimateDatesPanel />
				</Item>
			</Box>
			<Box>
				<Item ratio={1}>
					<CustomerInformationPanel />
				</Item>
				<Item ratio={1}>
					<StoreInformationPanel editableSalesAssocName={true} />
				</Item>
			</Box>

			<EstimateItemsGrid />

			<EstimateNotesGrid />

		</EstimatePage>
	)
}
